import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { Alert } from '@sainsburys-tech/bolt';

var Status = function Status(_ref) {
  var type = _ref.type;
  return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'error' && /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false
  }, "Oops something went wrong..."), type === 'loading' && /*#__PURE__*/React.createElement(ContentLoader, {
    viewBox: "0 0 400 680",
    speed: 1,
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb",
    uniqueKey: "qv-content-loader"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "0",
    ry: "0",
    width: "400",
    height: "250"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "280",
    rx: "0",
    ry: "0",
    width: "280",
    height: "40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "350",
    rx: "0",
    ry: "0",
    width: "140",
    height: "30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "385",
    rx: "0",
    ry: "0",
    width: "500",
    height: "300"
  })));
};

Status.displayName = 'Status';
Status.propTypes = {
  type: PropTypes.oneOf(['loading', 'error']).isRequired
};
Status.defaultProps = {
  type: 'loading'
};
export default Status;